import { Col, Row } from 'antd';
import { ConfirmButton } from 'components/common/DefaultFormButton';
import DefaultModal from 'components/common/DefaultModal';
import InputFieldsGenerator from 'components/InputFieldsGenerator';
import { InputProps } from 'components/InputFieldsGenerator/types';
import { Form, Formik } from 'formik';
import React, { useMemo } from 'react';
import { FormActionButtonStyled } from 'routes/Profile/components/ProfileContent/styled';
import { FormButtonType } from 'routes/Profile/components/ProfileContent/types';
import { GeneralFunction } from 'types/common';
import IntlMessages from 'utils/IntlMessages';
import { v4 as uuidv4 } from 'uuid';
import * as Yup from 'yup';

import { ISignatoryInputProps } from '../../types';

const SignatoryModal: React.FC<{
  modalType?: string;
  closeModal: GeneralFunction;
  addSignatory: (value: ISignatoryInputProps, id: string) => void;
  editSignatory: (newValue: ISignatoryInputProps, id: string) => void;
  isLoading?: boolean;
  data?: ISignatoryInputProps & { id: string };
}> = ({ modalType, closeModal, addSignatory, editSignatory, data, isLoading }) => {
  const signatorySchema = useMemo(
    () => ({
      firstName: Yup.string().required('Required'),
      lastName: Yup.string().required('Required'),
      email: Yup.string().email('Wrong email format').required('Required'),
      phone: Yup.string().validatePhoneNumber('Wrong format'),
      address1: Yup.string().notRequired(),
      // address2: Yup.string().notRequired(),
      city: Yup.string().notRequired(),
      state: Yup.string().notRequired(),
      zip: Yup.string()
        .matches(/(^\d{5}$)|(^\d{9}$)|(^\d{5}-\d{4}$)/, 'Wrong format')
        .notRequired(),
    }),
    [],
  );

  const formFields: InputProps[] = useMemo(
    () => [
      { label: 'Last Name', name: 'lastName', sideFields: [{ label: 'First Name', name: 'firstName', size: 12 }] },
      {
        label: 'Phone',
        name: 'phone',
        placeholder: 'Phone number',
        inputSettings: { isPhoneNumber: true },
        sideFields: [{ label: 'Email', name: 'email', size: 12 }],
      },
      // {
      //   label: (
      //     <span>
      //       Address Line 1 <i>(optional)</i>
      //     </span>
      //   ),
      //   name: 'address1',
      //   addressSuggestion: true,
      //   addressSuggestionSubFields: {
      //     address1: 'address1',
      //     city: 'city',
      //     zip: 'zip',
      //     state: 'state',
      //   },
      // },
      // {
      //   label: (
      //     <span>
      //       Address Line 2 <i>(optional)</i>
      //     </span>
      //   ),
      //   name: 'address2',
      // },
      // {
      //   label: (
      //     <span>
      //       City <i>(optional)</i>
      //     </span>
      //   ),
      //   name: 'city',
      // },
      // {
      //   label: (
      //     <span>
      //       Zip <i>(optional)</i>
      //     </span>
      //   ),
      //   name: 'zip',
      //   sideFields: [
      //     {
      //       label: (
      //         <span>
      //           State <i>(optional)</i>
      //         </span>
      //       ),
      //       name: 'state',
      //       type: INPUT_TYPE.SELECT,
      //       size: 12,
      //       inputOptions: usStatesSelectOptions,
      //     },
      //   ],
      // },
    ],
    [],
  );

  const initialValues = data || {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    // address1: '',
    // address2: '',
    // city: '',
    // state: '',
    // zip: '',
  };

  const onSubmit = (value: any) => {
    closeModal();
    if (modalType === 'addSignatory') addSignatory(value, uuidv4());
    else editSignatory(value, data?.id || '0');
  };

  const onCancel = () => {
    closeModal();
  };

  const isAddModal = modalType === 'addSignatory';
  const modalMainText = isAddModal ? 'Add Signatory' : 'Edit Signatory';

  return (
    <DefaultModal
      props={{
        title: modalMainText,
        visible: modalType === 'addSignatory' || modalType === 'editSignatory',
        destroyOnClose: true,
        onCancel,
        maskClosable: false,
      }}>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={Yup.object(signatorySchema)}>
        <Form className='gx-form-row0'>
          <InputFieldsGenerator formFields={formFields} />
          <Row>
            <Col flex='auto' style={{ marginLeft: '16px', marginTop: 10 }}>
              <ConfirmButton
                width='auto'
                isLoading={isLoading}
                buttonType='primary'
                htmlType='submit'
                className='gx-mb-0'>
                {modalMainText}
              </ConfirmButton>
              <FormActionButtonStyled
                buttonType='default'
                $type={FormButtonType.CANCEL}
                className='gx-mb-0'
                htmlType='button'
                onClick={onCancel}>
                <IntlMessages id='appModule.cancel' />
              </FormActionButtonStyled>
            </Col>
          </Row>
        </Form>
      </Formik>
    </DefaultModal>
  );
};

export default React.memo(SignatoryModal);
